<template>
<div class="flex justify-end items-center relative z-30">
<!--   <div
    class="relative w-full align-left outline-none leading-8"
    tabindex=0
    @blur="open = false"

  >
    <div
      class="bg-beige-academy-100 text-chocolate-academy-600 text-sm font-sans-serif pl-4
          shadow-md rounded-md cursor-pointer pr-10"
      :class="{open: open}"
      @click="open = !open"
    >
    </div>
    <div
      class="overflow-hidden font-sans-serif text-sm text-left shadow-md rounded-b-md absolute
       bg-white w-full z-10"
      :class="{selectHide: !open}"
    >
    </div>
  </div>
  <md-menu class="z-30" md-size="small" md-align-trigger>
    <md-button md-menu-trigger
      :class="isTeacher ? 'bg-beige-academy-100 text-chocolate-academy-600' :
      'bg-orange-academy-300 text-white'"
      class="flex w-auto relative capitalize font-sans-serif">
      <div class="mr-6">
        {{ selected }}
      </div>
      <div class="pointer-events-none absolute inset-y-0
        right-0 flex items-center pt-1 text-grey-academy-800">
          <svg class="fill-current h-4 w-4 relative" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657
            8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
          </svg>
      </div>
    </md-button>
    <md-menu-content>
      <md-menu-item v-for="(option, i) of options"
        :key="i"
        @click="selected=option.name; open=false; $emit('input', option.code)"
        class="bg-white backdrop-filter backdrop-blur-lg backdrop-opacity-10 z-30"
      >
        {{ option.name }}</md-menu-item>
    </md-menu-content>
  </md-menu>-->
  <md-field >
    <md-select v-model="selectedLocale"
      :class="isTeacher ? 'bg-white border-2 text-chocolate-academy-600' :
      'bg-white text-black border-2'"
      class="flex w-auto relative capitalize font-sans-serif pl-2" md-dense>
      <md-option v-for="option of options" :value="option.code"
        :key="option.code" @click="$emit('input', option.code)"
        class=" capitalize font-sans-serif bg-white"
        :class="isTeacher ? 'hover:bg-beige-academy-250 hover:text-chocolate-academy-600' :
        'hover:bg-orange-academy-150 hover:text-white'">
        {{ option.name }}
      </md-option>
    </md-select>
  </md-field>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';

export default {
  props: ['options'],

  data() {
    return {
      selectedLocale: this.$i18n.locale,
    };
  },

  watch: {
    selectedLocale() {
      this.updateLocale();
    },
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      isTeacher: 'auth/isTeacher',
      user: 'auth/user',
    }),
  },

  methods: {
    ...mapActions({
      changeLocale: 'auth/changeLocale',
    }),

    updateLocale() {
      this.$i18n.locale = this.selectedLocale;
      this.changeLocale();
      this.$store.dispatch('auth/auth');
      if (this.user) {
        this.updateUserLocale(this.selectedLocale, true);
      }
    },

    updateUserLocale() {
      axios.put(`/api/users/${this.user.id}`, { lang: this.selectedLocale }).then(() => {
        this.$store.dispatch('auth/me');
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },
};
</script>
